import { createColumnHelper } from '@tanstack/react-table'
import { NavLink } from 'react-router-dom'
import ActionButton from '../../components/shared/ActionButton'
import { EditIcon, ViewIcon } from '../../components/shared/Icons'

const columnHelper = createColumnHelper()
export const columns = [
  columnHelper.accessor('_id', {
    id: 'S/N',
    header: 'ID',
    cell: (info) => info.row.index + 1,
  }),
  columnHelper.accessor('name', {
    header: 'Name',
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('_id', {
    id: 'View',
    header: <span className="opacity-0">'View'</span>,
    cell: (info) => (
      <NavLink to={`/attributes/view/${info.getValue()}`}>
        <ActionButton>
          <ViewIcon />
          View
        </ActionButton>
      </NavLink>
    ),
  }),
  columnHelper.accessor('_id', {
    id: 'edit',
    header: <span className="opacity-0">'Edit'</span>,
    cell: (info) => (
      <NavLink to={`/attributes/edit/${info.getValue()}`}>
        <ActionButton className={'text-destructive'}>
          <EditIcon />
          Edit
        </ActionButton>
      </NavLink>
    ),
  }),
]
